import axios from "../lib/axios";
import { getCloudFunctionUrl } from "../utils/cloudFunctions";

const ANALYZE_VIDEO_SUBTITLES_TIMEOUT_MS = 540000;

export const analyzeVideoSubtitlesRequest = async ({
  token,
  url,
  subtitleOptions,
  language,
}) => {
  const { data } = await axios({
    method: "post",
    url: `${getCloudFunctionUrl("analyzeVideoSubtitles")}/analyzeVideoSubtitles`,
    data: {
      url,
      ...(subtitleOptions ? { subtitleOptions } : {}),
      ...(language ? { language } : {}),
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
    timeout: ANALYZE_VIDEO_SUBTITLES_TIMEOUT_MS,
  });

  return data;
};
